import React from 'react';
import { FinishNewsletterPopup } from '@husky-x/cc-finish-newsletter-popup';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { FinishNewsletterImageForm } from '@phx-husky/cc-finish-newsletter-image-form';
import { FinishProductDifferences } from '@phx-husky/cc-finish-product-differences';
import { FinishProductsCards } from '@phx-husky/cc-finish-products-cards';
import CustomPanAnimation from '@root/components/CustomPanAnimation';
import ImageMap from '@root/components/ImageMap';

import {
  FinishImageMapDropMock,
  FinishNewsletterPopupMock,
  FinishProductCardsMock,
  FinishProductDifferencesMock,
} from './custom-components-mocks';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'FinishProductDifferences',
        component: () => <FinishProductDifferences {...FinishProductDifferencesMock} />,
      },
      {
        key: 'FinishProductCards',
        // @ts-expect-error - cardsStyle in ProdCards is coded as set of specified strings - mocks provides those strings, but guardtypes them as 'string'
        component: () => <FinishProductsCards {...FinishProductCardsMock} />,
      },
      {
        key: 'FinishNewsletterPopup',
        component: () => <FinishNewsletterPopup {...FinishNewsletterPopupMock} />,
      },
      {
        key: 'custom_finish_newsletter_image_form',
        component: FinishNewsletterImageForm,
      },
      {
        key: 'finishImageMapDrop',
        component: (props) => <ImageMap {...props} map={FinishImageMapDropMock.map} />,
      },
      {
        key: 'FinishCouponPanAnimation',
        component: CustomPanAnimation,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
